<template>
  <reservation-detail class="pt-life-experience-pavilion-reservation__page"></reservation-detail>
</template>

<script>
import ReservationDetail from 'cps/appointment-application/pt-life-experience-pavilion-reservation/reservation-detail/index.vue'
export default {
  name: 'reservation-detail__view',
  components: {
    'reservation-detail': ReservationDetail
  }
}
</script>
